import { render, staticRenderFns } from "./pondlogsLogo.vue?vue&type=template&id=f854fbb8&scoped=true&"
import script from "./pondlogsLogo.vue?vue&type=script&lang=js&"
export * from "./pondlogsLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f854fbb8",
  null
  
)

export default component.exports